import React from 'react';
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import { Translate } from "react-redux-i18n";

function formatMarketCap(value) {
    const n = Number(value);
    if (Number.isNaN(n)) return value || '—';
    if (n >= 1e12) return `$${(n / 1e12).toFixed(2)}T`;
    if (n >= 1e9) return `$${(n / 1e9).toFixed(2)}B`;
    if (n >= 1e6) return `$${(n / 1e6).toFixed(2)}M`;
    return `$${n.toLocaleString()}`;
}

/** Dividend flag from API may be 0/1, "0"/"1", or amount — missing/zero → no. */
function paysDividend(value) {
    if (value === undefined || value === null || value === '') {
        return false;
    }
    if (typeof value === 'boolean') {
        return value;
    }
    if (typeof value === 'number') {
        return Number.isFinite(value) && value > 0;
    }
    const normalized = String(value).trim().toLowerCase();
    if (['0', 'false', 'no', 'n', 'off'].includes(normalized)) {
        return false;
    }
    if (['1', 'true', 'yes', 'y'].includes(normalized)) {
        return true;
    }
    const num = Number(normalized);
    return Number.isFinite(num) && num > 0;
}

const Fundamental = (props) => {
    const { item } = props;
    if (!item?.symbol) {
        return null;
    }

    const hasDividend = paysDividend(item.dividend);

    return (
        <section className="stock-card">
            <div className="stock-card-body">
                <h2 className="stock-section-title">
                    <Translate value="stock_fundamentals" />
                </h2>
                <div className="stock-stats-grid">
                    <div className="stock-stat">
                        <span className="stock-stat-label">
                            <Translate value="stock_market_cap" />
                        </span>
                        <span className="stock-stat-value">{formatMarketCap(item.market_cap)}</span>
                    </div>
                    <div className="stock-stat">
                        <span className="stock-stat-label">
                            <Translate value="stock_employees" />
                        </span>
                        <span className="stock-stat-value">
                            {item.total_employees
                                ? Number(item.total_employees).toLocaleString()
                                : '—'}
                        </span>
                    </div>
                    <div className="stock-stat">
                        <span className="stock-stat-label">
                            <Translate value="stock_list_date" />
                        </span>
                        <span className="stock-stat-value">{item.list_date || '—'}</span>
                    </div>
                    <div className="stock-stat">
                        <span className="stock-stat-label">
                            <Translate value="dividend" />
                        </span>
                        <span className="stock-stat-value">{hasDividend ? 'Yes' : 'No'}</span>
                    </div>
                </div>

                {item.description && (
                    <p className="stock-description">{item.description}</p>
                )}

                {(item.homepage_url || item.phone_number || item.city) && (
                    <div className="stock-meta">
                        {item.homepage_url && (
                            <a href={item.homepage_url} target="_blank" rel="noopener noreferrer">
                                {item.homepage_url.replace(/^https?:\/\//, '')}
                            </a>
                        )}
                        {item.phone_number && <span> · {item.phone_number}</span>}
                        {(item.city || item.state || item.postal_code) && (
                            <span>
                                {' · '}
                                {[item.address, item.city, item.state, item.postal_code]
                                    .filter(Boolean)
                                    .join(', ')}
                            </span>
                        )}
                    </div>
                )}
            </div>
        </section>
    );
};

Fundamental.propTypes = {
    className: PropTypes.string,
};

function mapStateToProps(reducer) {
    return {
        item: reducer.stock.item,
    };
}

export default connect(mapStateToProps)(Fundamental);
